import { APPOINTMENT_STATUS_LABELS } from "../constants";

export function appointmentStatusLabel(status) {
  return APPOINTMENT_STATUS_LABELS[status] || status;
}

export function subjectPatientRef(appointment) {
  return (
    appointment?.patients?.find((patient) => patient.role === "subject")?.patientRef ||
    appointment?.patients?.[0]?.patientRef ||
    appointment?.patientRefs?.[0]
  );
}
